export enum CANCELATION_STATUS_TYPES {
  NOT_CANCELLED = 'NOT_CANCELLED',
  PARTIALLY_CANCELLED = 'PARTIALLY_CANCELLED',
  CANCELLED = 'CANCELLED',
}
